import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';

type Errors = Record<'name' | 'componentLead', string>;

export class ComponentValidationError extends Error {
	errors: Errors;

	constructor(message: string, errors: Errors) {
		super(message);
		this.errors = errors || {};
	}
}

export type ComponentRequestError = ComponentValidationError | FetchError;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorFromResultJson = (resultJson: any, status: number): ComponentRequestError => {
	const errors = resultJson.errors;
	if (errors && (errors.name || errors.componentLead)) {
		return new ComponentValidationError('', {
			name: resultJson.errors.name,
			componentLead: resultJson.errors.componentLead,
		});
	}
	const errorMessage = resultJson.errorMessages && resultJson.errorMessages[0];
	return new FetchError(status, errorMessage);
};
